module.exports = __webpack_public_path__ + "img/25.73b81d88.jpg";